import { render, staticRenderFns } from "./t-header.vue?vue&type=template&id=632aa126&"
import script from "./t-header.vue?vue&type=script&lang=js&"
export * from "./t-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports